import http from "../api/http";
import { api } from "../api/environment";
import {
  ServerResponse,
  IRemision,
  IRemisionDetail,
  INewRemision,
  IUpdateRemision,
  IDeleteRemisionDetail,
  IRemisionName,
  IPayRemision,
  IApproveRemision,
  IMarkDetailDispatched,
  ICloseRemisionRequest,
  IDispatchMovement,
  IDispatchWarehouse,
  IStateChange,
  RemisionState,
} from "../types/global";

const getAll = (
  maxResultCount: number,
  skipCount?: number,
  search?: string,
  state?: RemisionState,
  expiredFilter?: number
) => {
  return http.get<ServerResponse<IRemision>>(
    `/services/app${api.REMISION_SERVICE}/GetAll?${
      maxResultCount ? "MaxResultCount=" + maxResultCount + "&" : ""
    }${skipCount ? "SkipCount=" + skipCount + "&" : ""}${
      search ? "Search=" + search + "&" : ""
    }${state === undefined ? "" : "State=" + state + "&"}${
      !expiredFilter ? "" : "statusFilter=" + expiredFilter + "&"
    }`
  );
};

const get = (id: number) => {
  return http.get<IRemisionDetail>(
    `/services/app${api.REMISION_SERVICE}/Get?Id=${id}`
  );
};

const create = (payload: INewRemision) => {
  return http.post(`/services/app${api.REMISION_SERVICE}/Create`, payload);
};

const remove = (id: number, employeeCode: string) => {
  return http.delete(
    `/services/app${api.REMISION_SERVICE}/Delete?Id=${id}&employeeCode=${employeeCode}`
  );
};

const pay = (payload: IPayRemision) => {
  return http.post(`/services/app${api.REMISION_SERVICE}/Pagar`, payload);
};

const put = (payload: IUpdateRemision | IDeleteRemisionDetail) => {
  return http.put(`/services/app${api.REMISION_SERVICE}/Update`, payload);
};

const putName = (payload: IRemisionName) => {
  return http.put(
    `/services/app${api.REMISION_SERVICE}/UpdateRemisionName`,
    payload
  );
};

const approve = (payload: IApproveRemision) => {
  return http.post(
    `/services/app${api.REMISION_SERVICE}/ApproveForDispatch`,
    payload
  );
};

const revokeApproval = (payload: IApproveRemision) => {
  return http.post(
    `/services/app${api.REMISION_SERVICE}/RevokeApproval`,
    payload
  );
};

const markDetailDispatched = (payload: IMarkDetailDispatched) => {
  return http.post(
    `/services/app${api.REMISION_SERVICE}/MarkDetailDispatched`,
    payload
  );
};

const closeRemision = (payload: ICloseRemisionRequest) => {
  return http.post(
    `/services/app${api.REMISION_SERVICE}/CloseRemision`,
    payload
  );
};

const getDispatchMovements = (detailId: number) => {
  return http.get<IDispatchMovement[]>(
    `/services/app${api.REMISION_SERVICE}/GetDispatchMovements?detailId=${detailId}`
  );
};

const getStateHistory = (remisionId: number) => {
  return http.get<IStateChange[]>(
    `/services/app${api.REMISION_SERVICE}/GetStateChanges?remisionId=${remisionId}`
  );
};

const getDispatchWarehouses = () => {
  return http.get<IDispatchWarehouse[]>(
    `/services/app${api.REMISION_SERVICE}/GetDispatchWarehouses`
  );
};

export const remisionService = {
  getAll,
  get,
  create,
  remove,
  pay,
  put,
  putName,
  approve,
  revokeApproval,
  markDetailDispatched,
  closeRemision,
  getDispatchMovements,
  getStateHistory,
  getDispatchWarehouses,
};
